import React from "react";
import { useDispatch } from "react-redux";

import MoreOptionsIconButton from "modules/common/components/buttons/moreOptionsIconButton";

import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import MoreOptionsItem from "modules/common/components/moreOptionsItem";

import { TopicGroup } from "../../models";
import { Typography } from "@mui/material";
import { TopicDeletionHandler } from "modules/topics/utils/topicDeletionHandler";
import { editTopicState } from "modules/topics/reducer";

const MoreTopicGroupOptions: React.FunctionComponent<ComponentProps> = props => {
    const atLeastOneEnabled = () => props.topicGroup.tags.some(t => !t.disabled);

    const dispatch = useDispatch();

    const onHandleDelete = () => {
        const topics = {
            topics: [...props.topicGroup.tags],
            topicGroups: [props.topicGroup]
        };
        new TopicDeletionHandler(topics, dispatch).onHandleDelete();
    };

    const handleStateUpdate = (disable: boolean) => {
        const topics = props.topicGroup.tags.map(t => t.id);
        dispatch(editTopicState({ topics, disable }));
    };

    const deleteTopicGroupText = (): JSX.Element =>
        <Typography className="red-text">
            Delete topic group
        </Typography>;

    return (
        <MoreOptionsIconButton>
            <List disablePadding>
                <MoreOptionsItem
                    text="Add new topic"
                    onClick={props.createTopicDialog}
                />
                <Divider light />
                <MoreOptionsItem
                    text="Rename"
                    onClick={props.editGroupDialog}
                />
                <Divider light />

                <MoreOptionsItem
                    text={atLeastOneEnabled() ? "Disable all" : "Enable all"}
                    onClick={() => handleStateUpdate(atLeastOneEnabled())}
                />

                <MoreOptionsItem
                    text={deleteTopicGroupText()}
                    onClick={onHandleDelete}
                />

            </List>
        </MoreOptionsIconButton>
    );
};

interface ComponentProps {
    topicGroup: TopicGroup;
    createTopicDialog: () => void;
    editGroupDialog: () => void;
}

export default MoreTopicGroupOptions;